import React from 'react';
import { Drawer, Box, Typography, Card, CardContent, Stack, Chip, alpha } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const PrevPricingVersionCard = ({ open, onClose, prevVersions = [] }) => {
  const openVersionInNewTab = version => {
    const url = `/timberSalesPricing/${version.siteAssessmentID}/${version.pricingVersion}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '100vw', sm: 500 },
        },
      }}>
      <Box sx={{ p: 2.5 }}>
        <Typography variant="h6" fontWeight={600} mb={2}>
          Previous Versions
        </Typography>

        <Stack spacing={2}>
          {prevVersions.map(version => (
            <Card
              key={version.id}
              onClick={() => openVersionInNewTab(version)}
              sx={{
                cursor: 'pointer',
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider',
                transition: 'all 0.2s ease',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 4,
                  borderColor: 'primary.main',
                },
              }}>
              <CardContent>
                <Stack direction="row" justifyContent="space-between" alignItems="center" mb={0.5}>
                  <Typography fontWeight={600}>Version {version.pricingVersion}</Typography>
                  <OpenInNewIcon fontSize="small" />
                </Stack>

                <Typography variant="caption" color="text.secondary">
                  {version.timberPricingLabel}
                </Typography>

                <Stack direction="row" spacing={1} mt={1} flexWrap="wrap">
                  <Chip
                    size="small"
                    label={`${version.products} products`}
                    sx={theme => ({
                      bgcolor: alpha(theme.palette.text.primary, 0.08),
                      color: theme.palette.text.primary,
                      fontWeight: 500,
                    })}
                  />

                  {version.totalM3 && (
                    <Chip
                      size="small"
                      label={`• ${Math.round(version.totalM3)} m³`}
                      sx={theme => ({
                        bgcolor: alpha(theme.palette.info.main, 0.1),
                        color: theme.palette.info.dark,
                      })}
                    />
                  )}

                  {version.totalTonnes && (
                    <Chip
                      size="small"
                      label={`• ${Math.round(version.totalTonnes)} tons`}
                      sx={theme => ({
                        bgcolor: alpha(theme.palette.success.main, 0.1),
                        color: theme.palette.success.dark,
                      })}
                    />
                  )}
                </Stack>
              </CardContent>
            </Card>
          ))}
        </Stack>
      </Box>
    </Drawer>
  );
};

export default PrevPricingVersionCard;
